const icon = require('vue-svgicon');
icon.register({
    'rutube': {
        width: 20,
        height: 20,
        viewBox: '0 0 20 20',
        data: `<path pid="0" d="M13.572 4.748H2.293v12.171h3.14v-3.96h6.016l2.745 3.96h3.516l-3.027-3.978c.94-.146 1.617-.493 2.03-1.04.414-.547.62-1.423.62-2.591v-.912c0-.694-.075-1.241-.206-1.661a2.758 2.758 0 00-.677-1.113 3.081 3.081 0 00-1.166-.675c-.45-.128-1.015-.201-1.71-.201zm-.507 5.53H5.432V7.43h7.633c.432 0 .733.073.883.201.15.128.245.365.245.712v1.022c0 .364-.094.602-.245.73-.15.127-.45.182-.883.182v0z" _stroke="#F9F9FC" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/><path pid="1" d="M17.076 4.54a1.042 1.042 0 100-2.084 1.042 1.042 0 000 2.083z" _fill="#F9F9FC"/>`,
    },
});
